import { useUpdateAnalyticsAfterDataChange } from './internal/hooks/useUpdateAnalyticsAfterDataChange';
import { useUpdateOnBoundsChange } from './internal/hooks/useUpdateOnBoundsChange';
import { useUpdateOnFiltersUpdate } from './internal/hooks/useUpdateOnFiltersUpdate';
import { useUpdateSeoAfterDataChange } from './internal/hooks/useUpdateSeoAfterDataChange';
import { useUpdateSimilarOffersOnListingUpdate } from './internal/hooks/useUpdateSimilarOffersOnListingUpdate';

export function useListingRefresh(): void {
  useUpdateOnFiltersUpdate();
  useUpdateAnalyticsAfterDataChange();
  useUpdateSimilarOffersOnListingUpdate();
  useUpdateOnBoundsChange();
  useUpdateSeoAfterDataChange();
}
